import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import CatalogItem from '../CatalogItem';

import { ICatalogList } from './interface';
import bemClassName from '../../utils/bem';

import './index.scss';
import Loading from '../../UI/Loading';
import Modal from '../../UI/Modal';
import Button from '../../UI/Button';
import { RootState } from '../../store';
import PrivateData from '../../API/PrivateData';

const catalogList = bemClassName('catalog-list');

const CatalogList: React.FC<ICatalogList> = ({ data, fav, current, currentData }) => {
  const isLogin = useSelector((state: RootState) => state.autorizationStatus.isLogin);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [isOpen, setOpen] = useState<boolean>(false);
  const isPaswordVerified = useSelector(
    (state: RootState) => state.autorizationStatus.isPaswordVerified,
  );

  const handleCloseVerifyModal = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (event) {
      event.preventDefault();
    }
    setOpen(false);
  };

  const handleExternal = (value: boolean) => {
    setIsLoading(value);
  };

  useEffect(() => {
    setOpen(false);
    if (isLogin && !isPaswordVerified && !isOpen) {
      PrivateData.checkPreapprove().then((item) => {
        if (!item) {
          setOpen(true);
        }
      });
    }
  }, [isPaswordVerified]);

  useEffect(() => {
    if (isLoading) {
      if (isLoading) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }
  }, [isLoading]);

  return (
    <>
      <div className={catalogList()}>
        {isLoading && (
          <div className={catalogList('carousel-box')}>
            <div className={catalogList('carousel')}>
              <Loading externalClassName={catalogList('loading')} />
              <p className={catalogList('loading-text')}>Идёт загрузка</p>
            </div>
          </div>
        )}
        {data &&
          data.length > 0 &&
          data.map((item, index) => {
            return (
              <CatalogItem
                // key={item.id}
                key={currentData ? currentData[index].id : item.id}
                // key={currentData[index].id}
                data={item}
                fav={fav}
                current={current}
                currentData={currentData}
                loading={handleExternal}
              />
            );
          })}
      </div>
      <Modal open={isOpen} handleClose={handleCloseVerifyModal}>
        <h3>Внимание!</h3>
        <p>
          Бесконтактное заселение в квартиру доступно только для верифицированных пользователей.
          Верификация доступна в{' '}
          <Link to="/account#proof-of-identity" className={catalogList('link-modal')}>
            личном кабинете
          </Link>
          .
        </p>
        <Button
          text="Ок"
          handleExternal={(event: React.MouseEvent<HTMLButtonElement>) =>
            handleCloseVerifyModal(event)
          }
        />
      </Modal>
    </>
  );
};

export default CatalogList;
